export default __webpack_public_path__ + "static/media/caja.ddb2fd1c.png";